import { action, observable, makeObservable } from 'mobx';

class SelectedResultInfoStore {
  selectedResultInfo = {};

  constructor() {
    makeObservable(this, {
      selectedResultInfo: observable,
      setSelectedResultInfo: action.bound,
    });
  }

  setSelectedResultInfo(selectedResult) {
    this.selectedResultInfo = selectedResult;
  }
}

export const selectedResultInfoStore = new SelectedResultInfoStore();
